export const ALPHA_DEFAULT_INTEREST = 13
export const ALPHA_SALARIED_INTEREST = 11
export const ALPHA_DEFAULT_CONTRIBUTION = 0.6
export const ALPHA_DEFAULT_FEE = 70
export const ALPHA_MAX_LOAN_AMOUNT = 5000
export const ALPHA_MIN_LOAN_AMOUNT = 500
